const translations = {
    cancel: 'Cancel',
    clearProductUsageReportsAriaLabel: 'Clear product usage reports',
    clearWorkOrderAriaLabel: 'Clear work order',
    drawerTitle: 'Edit flight group',
    loading: 'Loading…',
    nameLabel: 'Group name',
    namePlaceholder: 'Enter a name',
    productUsageReportsLabel: 'Product usage reports',
    productUsageReportsPlaceholder: 'Select reports',
    save: 'Save',
    saveError: 'Failed to save changes. Please try again.',
    saving: 'Saving…',
    workOrderLabel: 'Work order',
    workOrderPlaceholder: 'Select a work order'
};

export default translations;
